'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Trophy = require('./Trophy');

var _Trophy2 = _interopRequireDefault(_Trophy);

var _FormButton = require('../../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FlexCenter = require('../../../../components/misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

require('./PaymentSuccess.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentSuccess = function PaymentSuccess(_ref) {
    var dispatchResetPayment = _ref.dispatchResetPayment;
    return _react2.default.createElement(
        _FlexCenter2.default,
        { className: 'PaymentSuccess' },
        _react2.default.createElement(_Trophy2.default, null),
        _react2.default.createElement(
            'h1',
            null,
            'Congratulations'
        ),
        _react2.default.createElement(
            'p',
            null,
            'You\u2019ve upgraded to professional plan'
        ),
        _react2.default.createElement(
            _FormButton2.default,
            { className: 'primary', onClickFn: dispatchResetPayment },
            'OK'
        )
    );
};

PaymentSuccess.propTypes = {
    dispatchResetPayment: _propTypes2.default.func
};

exports.default = PaymentSuccess;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/success/PaymentSuccess.js
// module id = 2065
// module chunks = 0